import { RefObject, useLayoutEffect, useState } from "react";

type Options = {
  minHeight?: number;
  bottomPadding?: number;
};

export function useFillViewportHeight(
  ref: RefObject<HTMLElement | null>,
  { minHeight = 400, bottomPadding = 24 }: Options = {},
) {
  const [height, setHeight] = useState<number | null>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    function update() {
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      const available = window.innerHeight - top - bottomPadding;
      setHeight(Math.max(minHeight, available));
    }

    update();

    const observer = new ResizeObserver(update);
    observer.observe(document.body);
    window.addEventListener("resize", update);
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", update);
    };
  }, [ref, minHeight, bottomPadding]);

  return height;
}
